export default __webpack_public_path__ + "static/media/Textilslöjd3.c6d8ffe4.jpeg";